export default __webpack_public_path__ + "static/media/DFSInfo.b6930117.md";